module.exports = __webpack_public_path__ + "media/images/emoticons/new-da55222082472d257cf63a188d25c931.gif";